/** Transport-neutral live-call action orchestration. */

export function syncConnectedMuteState(ctx) {
    const muted = Boolean(ctx.isMuted() || ctx.isTransportMuted());
    ctx.setMuted(muted);
    ctx.setConversationActive(!muted);
    ctx.setMutedControl(muted);
    ctx.renderConnectedState(muted);
    return muted;
}

export function showInactiveConversationControl(ctx) {
    ctx.setConversationActive(false);
    ctx.showControl();
}

export function muteVideocall(ctx) {
    const transport = ctx.getTransport();
    ctx.setConversationActive(false);
    ctx.setMuted(true);
    ctx.setAudioPlaying(false);
    ctx.stopAudio();

    if (transport === 'livekit') ctx.setLiveKitMuted(true);
    else if (transport === 'webrtc') ctx.setWebRTCMuted(true);
    else ctx.muteLegacy();

    ctx.renderMutedState(transport);
    return transport;
}

export function unmuteVideocall(ctx) {
    const transport = ctx.getTransport();
    ctx.setConversationActive(true);
    ctx.setMuted(false);

    if (transport === 'livekit') ctx.setLiveKitMuted(false);
    else if (transport === 'webrtc') ctx.setWebRTCMuted(false);
    else ctx.unmuteLegacy();

    ctx.renderUnmutedState(transport);
    return transport;
}

export function toggleVideocallMute(muted, ctx) {
    return muted ? ctx.unmute() : ctx.mute();
}

export function hangupVideocall(ctx) {
    ctx.setModalOpen(false);
    ctx.setMuted(false);
    ctx.setRecordingTriggered(false);
    ctx.setReconnectAttempts(ctx.maxReconnectAttempts);
    ctx.stopAudio();
    ctx.stopRecording();
    ctx.closeSocket();
    ctx.abortAjax();
    ctx.hideModal();
    ctx.clearPresentation();
}
